/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_And_Register_TitleInputs */



/**
* | output |
* | --- |
* | "Register New Player" |
*
* @param {Create_And_Register_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_and_register_title = /** @type {((inputs?: Create_And_Register_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_And_Register_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrire un nouveau joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscribir Nuevo Jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrever Novo Jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscrivi Nuovo Giocatore")
	return /** @type {LocalizedString} */ ("Register New Player")
});